import { render, staticRenderFns } from "./EditAuthorizedSigner.vue?vue&type=template&id=132c14fa&scoped=true"
import script from "./EditAuthorizedSigner.vue?vue&type=script&lang=ts"
export * from "./EditAuthorizedSigner.vue?vue&type=script&lang=ts"
import style0 from "./EditAuthorizedSigner.vue?vue&type=style&index=0&id=132c14fa&prod&lang=scss&scoped=true"
import style1 from "./EditAuthorizedSigner.vue?vue&type=style&index=1&id=132c14fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132c14fa",
  null
  
)

export default component.exports